import React from 'react'
import { NavLink } from 'react-router-dom'
import Logo from './Logo'
import styles from '../../styles/MainNavigation.module.css'
import { URL } from '../../constants'
import CommonNavigation from './CommonNavigation'


const MainNavigation = ({ showMenus = true }: any) => {

    return (
        <nav className="navbar navbar-expand-lg fixed-top navbar-light bg-white" id={styles.mainNavigation}>
            <div className="container">
                <Logo width='auto' height='44px' alt="Logo" />
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse justify-content-end" id="navbarText">
                    {
                        showMenus &&
                        <ul className={`navbar-nav me-auto mb-2 mb-lg-0 ${styles.navbarNav}`}>
                            <li className="nav-item font-weight-semibold px-2">
                                <NavLink className={({ isActive }) => (isActive ? styles.activeTab : '') + ` nav-link ${styles.navLink}`} to={URL.home} end>Home</NavLink>
                            </li>
                            <li className="nav-item font-weight-semibold px-2">
                                <NavLink className={({ isActive }) => (isActive ? styles.activeTab : '') + ` nav-link ${styles.navLink}`} to={URL.dashboard}>Dashboard</NavLink>
                            </li>
                            <li className="nav-item font-weight-semibold px-2">
                                <NavLink className={({ isActive }) => (isActive ? styles.activeTab : '') + ` nav-link ${styles.navLink}`} to={URL.search}>Search</NavLink>
                            </li>
                            <li className="nav-item font-weight-semibold px-2">
                                <NavLink className={({ isActive }) => (isActive ? styles.activeTab : '') + ` nav-link ${styles.navLink}`} to={URL.integrations}>Integrations</NavLink>
                            </li>
                        </ul>
                    }
                    <CommonNavigation />
                </div>
            </div>
        </nav>
    )
}

export default MainNavigation
